var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 80,
    viewBox: "0 0 371 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.342 59.882C.7 59.35 1.31 59 2 59h6V21H1.987A2 2 0 0 1 0 19v-9a2 2 0 0 1 2-2h7V2a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v6h328V2a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v6h6a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-6v38h6a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-6v6a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-6H22v6a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-6H2a2 2 0 0 1-2-2v-9c0-.414.126-.799.342-1.118Z",
    fill: "#BB6EA9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonFull);
export default __webpack_public_path__ + "static/media/button_full.6174db0b2ccb48718d24223e299707c0.svg";
export { ForwardRef as ReactComponent };